export function PageHeader({ title, description, action }) {
  return (
    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-end gap-3">
      <div>
        <h2 className="mb-2">{title}</h2>
        <p className="text-secondary mb-0">{description}</p>
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
